import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { bookFromSlugs, pageTitle } from "../config/site";
import { storySpanLabel } from "../data/book-summary";
import { loadBookHome, type BookHome } from "../data/load-book-home";
import { BookHero } from "./BookHero";
import { NotFoundPage } from "./NotFoundPage";

export function BookPage() {
  const { seriesSlug, bookSlug } = useParams();
  const book = bookFromSlugs(seriesSlug, bookSlug);
  const [home, setHome] = useState<BookHome | null>(null);

  useEffect(() => {
    if (book !== undefined) {
      void loadBookHome(book.id).then((loaded) => {
        document.title = pageTitle(loaded.summary.title);
        setHome(loaded);
      });
    }
  }, [book]);

  if (book === undefined) {
    return <NotFoundPage />;
  }
  return (
    <div className="landing">
      {home === null ? null : (
        <BookHero
          home={home}
          span={storySpanLabel(home.summary.storyFrom, home.summary.storyTo)}
        />
      )}
    </div>
  );
}
